import React, { useEffect } from "react";
import AOS from "aos";
import { Route, Routes, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";

import Header from "./components/header";
import Footer from "./components/footer";
import "../src/assets/font/font-awesome.css";
import routes from "./pages";
import Page404 from "./pages/404";
import { htmlLang, localeFromPath } from "./lib/i18n-routes";
import { organizationSchema } from "./components/seo/Seo";

import "./i18n"

/**
 * Tilni URL'dan o'qib i18n'ga beradi.
 * `?lang=ru` + sahifani qayta yuklash o'rniga — `/ru/...` prefiksi.
 */
function LocaleSync() {
  const { pathname } = useLocation();
  const { i18n } = useTranslation();
  const locale = localeFromPath(pathname);

  useEffect(() => {
    if (i18n.language !== locale) {
      i18n.changeLanguage(locale);
    }
    try {
      localStorage.setItem("lang", locale);
    } catch (e) {
      // localStorage yopiq bo'lishi mumkin (private mode) — muhim emas
    }
  }, [locale, i18n]);

  return (
    <Helmet>
      <html lang={htmlLang(locale)} />
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema(locale))}
      </script>
    </Helmet>
  );
}

function App() {
  useEffect(() => {
    AOS.init({
      duration: 2000,
    });
  }, []);

  return (
    <>
      <LocaleSync />
      <Header />

      <Routes>
        {routes.map((data, idx) => (
          <Route key={idx} path={data.path} element={data.component} />
        ))}

        <Route path="*" element={<Page404 />} />
      </Routes>

      <Footer />
    </>
  );
}

export default App;
